"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.VideoMarkerSchema = void 0;
exports.VideoMarkerSchema = {
    "$id": "https://www.redbull.com/schemas/video-markers.schema.json",
    "$schema": "https://json-schema.org/draft/2020-12/schema",
    "title": "VideoMarker",
    "description": "Video markers for a given content resource",
    "type": "object",
    "required": [
        "id",
        "type",
        "attributes",
        "relationships",
        "meta"
    ],
    "properties": {
        "id": {
            "type": "string",
            "pattern": "^rrn:video-markers:[0-9a-z\\-_]+:[0-9a-f]{8}[-]?([0-9a-f]{4}[-]?){3}[0-9a-f]{12}:[a-z]{2}-[A-Z]{2,3}$"
        },
        "type": {
            "type": "string",
            "pattern": "^rrn:video-markers:[0-9a-z\\-_]+$"
        },
        "attributes": {
            "type": "object",
            "additionalProperties": false,
            "properties": {
                "markers": {
                    "type": "array",
                    "items": {
                        "anyOf": [
                            {
                                "type": "object",
                                "additionalProperties": false,
                                "properties": {
                                    "durationInSeconds": {
                                        "type": "integer"
                                    },
                                    "timestamp": {
                                        "description": "The timestamp of the marker in seconds.",
                                        "$ref": "https://www.redbull.com/schemas/attributes/timestamp.schema.json"
                                    },
                                    "title": {
                                        "description": "The title of the chapter marker.",
                                        "$ref": "https://www.redbull.com/schemas/attributes/text.schema.json"
                                    },
                                    "type": {
                                        "type": "string",
                                        "pattern": "video-markers:chapter"
                                    }
                                },
                                "required": [
                                    "type",
                                    "title",
                                    "timestamp"
                                ]
                            },
                            {
                                "type": "object",
                                "additionalProperties": false,
                                "properties": {
                                    "durationInSeconds": {
                                        "type": "integer"
                                    },
                                    "timestamp": {
                                        "description": "The timestamp of the marker in seconds.",
                                        "$ref": "https://www.redbull.com/schemas/attributes/timestamp.schema.json"
                                    },
                                    "title": {
                                        "description": "The title of the reference marker.",
                                        "$ref": "https://www.redbull.com/schemas/attributes/text.schema.json"
                                    },
                                    "type": {
                                        "const": "video-markers:reference"
                                    },
                                    "reference": {
                                        "$ref": "https://www.redbull.com/schemas/attributes/web-link.schema.json"
                                    }
                                },
                                "required": [
                                    "type",
                                    "title",
                                    "timestamp",
                                    "reference"
                                ]
                            },
                            {
                                "type": "object",
                                "additionalProperties": false,
                                "properties": {
                                    "durationInSeconds": {
                                        "type": "integer"
                                    },
                                    "timestamp": {
                                        "description": "The timestamp of the marker in seconds.",
                                        "$ref": "https://www.redbull.com/schemas/attributes/timestamp.schema.json"
                                    },
                                    "title": {
                                        "description": "The title of the resource marker.",
                                        "$ref": "https://www.redbull.com/schemas/attributes/text.schema.json"
                                    },
                                    "type": {
                                        "const": "video-markers:resource"
                                    },
                                    "reference": {
                                        "$ref": "https://www.redbull.com/schemas/reference/type-groups/content.schema.json"
                                    }
                                },
                                "required": [
                                    "type",
                                    "title",
                                    "timestamp",
                                    "reference"
                                ]
                            }
                        ]
                    }
                }
            },
            "required": [
                "markers"
            ]
        },
        "relationships": {
            "type": "object",
            "additionalProperties": false,
            "properties": {
                "videoResource": {
                    "type": "object",
                    "description": "The resource the video markers belong to.",
                    "properties": {
                        "data": {
                            "$ref": "https://www.redbull.com/schemas/reference/type-groups/content.schema.json"
                        }
                    },
                    "required": [
                        "data"
                    ]
                }
            },
            "required": [
                "videoResource"
            ]
        },
        "meta": {
            "type": "object",
            "additionalProperties": false,
            "properties": {
                "hasUnconfirmedEssenceChanges": {
                    "type": "boolean",
                    "description": "Indicates if the video markers have unconfirmed essence changes."
                },
                "externalReference": {
                    "type": "object",
                    "description": "The external reference of the video markers.",
                    "properties": {
                        "origin": {
                            "type": "string"
                        },
                        "type": {
                            "type": "string",
                            "const": "attributes:external-reference"
                        },
                        "foreignId": {
                            "type": "string",
                            "pattern": "^([0-9]+-[0-9]+|AA-[A-Z0-9]{13}|AA[A-Z|0-9]{18})$"
                        }
                    },
                    "required": [
                        "foreignId",
                        "origin"
                    ]
                }
            },
            "required": [
                "externalReference"
            ]
        }
    },
    "additionalProperties": false
};
//# sourceMappingURL=data:application/json;base64,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